define('Components/GlossaryWidget/js/models/GlossaryWidgetInstanceModel',[
    'jquery',
    'WidgetInstanceModel',
    'app'
], function (
    $,
    WidgetInstanceModel,
    app
) {

    return WidgetInstanceModel.extend({
        setup: function () {
        },
        getIngredients: function () {
            return app.getIngredients();
        },
    })
});

